import HomeView from './views/HomeView/HomeView'

// Sync route definition
export default {
  component: HomeView,
}
